import { HOST_TULUM, API, HOST } from '@/utils/http'

const layerToFeature = (layer) => {
  return {
    uuid: layer.code,
    type: 'Feature',
    geometry: layer.layer?.geometry ? layer.layer.geometry : null,
    properties: {
      type: layer.type,
      visible: false,
      code: layer.code,
      name: layer.name,
      organization_id: layer.org_id,
      layer: layer.layer,
      created_at: layer.created_at,
      updated_at: layer.updated_at
    }
  }
}

export const fetchOrgLayers = async ({ commit }, { orgId }) => {
  try {
    const response = await API({
      method: 'GET',
      url: `${HOST}/org/${orgId}/layers/all`
    })

    const layers = response.data
      .map(layerToFeature)
      .sort((a, b) => new Date(b.properties.created_at) - new Date(a.properties.created_at))

    commit('SET_ORG_LAYERS', { orgId, layers })
    return layers
  } catch (error) {
    console.error('Error fetching organization layers:', error)
    throw error
  }
}

export const addOrgLayer = ({ commit }, { orgId, layer }) => {
  const featureLayer = layerToFeature(layer)
  commit('ADD_ORG_LAYER', { orgId, layer: featureLayer })
  return featureLayer
}

export const updateOrgLayer = ({ state,commit }, { orgId, layer }) => {
  commit('UPDATE_ORG_LAYER', { orgId, layer })
  return layer
}

export const updateOrgLayerFeatures = ({ commit }, { orgId, layerId, features }) => {
  commit('UPDATE_ORG_LAYER_FEATURES', { orgId, layerId, features })
  return features
}

export const deleteOrgLayer = async ({ commit }, { orgId, layerId }) => {
  try {
    // Validate parameters
    if (!orgId || !layerId) {
      throw new Error('Missing required parameters: orgId and layerId are required')
    }

    // Log deletion attempt for debugging
    console.warn('DELETING LAYER:', {
      orgId,
      layerId,
      timestamp: new Date().toISOString(),
      stack: new Error().stack
    })

    await API({
      method: 'DELETE',
      url: `${HOST}/org/${orgId}/layers/${layerId}`
    })

    commit('DELETE_ORG_LAYER', { orgId, layerId })
    return true
  } catch (error) {
    console.error('Error deleting organization layer:', error)
    throw error
  }
}

export const setSelectedFeature = ({ commit }, { feature, coordinates, isVisible }) => {
  commit('SET_SELECTED_FEATURE', { feature, coordinates, isVisible })
}

export const fetchLayers = async ({commit}, payload) => {
  const response = await API({
    method: 'GET',
    url: `${HOST_TULUM}/layers/${payload.org_id}`
  })
}
